<script lang="ts">
  import {
    insuranceIsNonRefundable,
    NonRefundableAdjustment,
    totalClaimable,
  } from "@models/cancellations/NonRefundableAdjustment"
  import { InsurancePlan } from "@models/insurance/InsurancePlan"
  import { formatCentsAsUsd } from "@util/money"

  export let insurancePlan: InsurancePlan | undefined
  export let nonRefundableAdjustments: NonRefundableAdjustment[]
  export let insuranceOnly: boolean = false
</script>

<div>
  <p role="status" id="coverage-details-status" data-role="coverage-details">
    {#if insurancePlan}
      {#if insuranceOnly || insuranceIsNonRefundable(nonRefundableAdjustments)}
        <strong class="text-gray-900">{insurancePlan.name}</strong> has been purchased for this passenger. They may be
        eligible for a refund of any non-refundable items listed above up to the amount of
        <strong class="text-gray-900">
          {formatCentsAsUsd(totalClaimable(nonRefundableAdjustments))}
        </strong>
      {:else}
        There are no non-refundable items to file a claim for. <strong class="text-gray-900"
          >The cost of {insurancePlan.name} will be refunded and the policy will be cancelled.</strong>
      {/if}
    {:else}
      This traveler has not purchased any travel protection.
    {/if}
  </p>
</div>
